import { Paragraph } from "./paragraph.model";

export class StoryPageParagraph{
    DOMElement?: HTMLElement;
    allSinglePageText?: string;
    allParagraphs?: Paragraph[];
} 